// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RCk6","field":"styles_field__3pdHb","fieldCol":"styles_fieldCol__2vIxs","diffCol":"styles_diffCol__1lhp7","diff":"styles_diff__2lIsQ"};